<template>
  <tela-component title="Formação de Carga">
    <carregando-padrao v-if="loading" />
    <template v-else>
      <v-row>
        <v-col cols="12">
          <v-btn
            rounded
            color="info"
            @click="$router.push({ path: '/formacao-carga/adicionar' })"
            v-if="!isMobile()"
            ><v-icon class="mr-2">mdi-truck-plus-outline</v-icon
            >Adicionar</v-btn
          >
          <v-btn
            v-else
            fab
            fixed
            bottom
            right
            color="info"
            @click="$router.push({ path: '/formacao-carga/adicionar' })"
            title="Adicionar formação de carga"
            ><v-icon>mdi-plus</v-icon></v-btn
          >
          <v-btn
            rounded
            color="secondary"
            @click="$router.push({ path: '/formacao-carga/configuracoes' })"
            :block="isMobile()"
            v-if="configuracoes.dados.habilita_config"
            text
            class="float-right"
            ><v-icon class="mr-2">mdi-cog-outline</v-icon>Configurações</v-btn
          >
        </v-col>
      </v-row>
      <v-card flat rounded="lg" class="mt-2">
        <v-card-text>
          <v-row :dense="isMobile()">
            <v-col xl="auto" lg="auto" md="auto" cols="12" align-self="center">
              <btn-filtro-form-cargas />
            </v-col>
            <v-col xl="6" lg="6" md="6" cols="12">
              <v-text-field
                label="Pesquisar"
                v-model="pesquisar"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-progress-linear
            indeterminate
            v-if="cargas.carregando"
          ></v-progress-linear>
          <v-data-table
            v-else
            :items="cargas.dados.cargas"
            :headers="cargas.dados.headers"
            no-data-text="Nenhuma formação de carga encontrada"
            no-results-text="Nenhuma carga localizada com este filtro"
            :search="pesquisar"
            loading-text="Aguarde... buscando cargas..."
            :loading="cargas.carregando"
            :header-props="{ sortByText: 'Ordenar por' }"
            :sort-by="['desc_vendedor']"
            multi-sort
          >
            <template v-slot:[`item.data`]="{ item }">
              {{ formatarData(item.data) }}
            </template>
            <template v-slot:[`item.data_hora_prog_carreg`]="{ item }">
              {{ formatarProgCarreg(item.data_hora_prog_carreg) }}
            </template>

            <template v-slot:[`item.prioridade.codigo`]="{ item }">
              <chip-prioridade-form-carga
                :prioridade="item.prioridade"
                xsmall
              />
              <btn-alterar-prioridade-form-carga
                :carga="item"
                v-if="item.prioridade.permite_alterar && item.pode_editar"
              />
            </template>

            <template v-slot:[`item.placa`]="{ item }">
              <span class="font-weight-bold">{{ item.placa }}</span>
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <v-chip
                :style="JSON.parse(item.status_css)"
                x-small
                class="caption"
                >{{ item.status }}</v-chip
              >
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                icon
                color="teal"
                title="Detalhes da carga"
                @click="
                  $router.push({ path: `/formacao-carga/detalhes/${item.id}` })
                "
                ><v-icon>mdi-truck-outline</v-icon></v-btn
              >

              <v-btn
                v-if="item.pode_editar"
                icon
                color="info"
                title="Editar"
                @click="
                  $router.push({
                    path: `/formacao-carga/${item.id}`,
                  })
                "
                ><v-icon>mdi-pencil</v-icon></v-btn
              >
              <btn-remover-formacao-carga
                :carga="item"
                v-if="item.pode_excluir"
              />
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <router-view></router-view>
    </template>
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import moment from "moment";
import BtnRemoverFormacaoCarga from "@/components/formacao-carga/BtnRemoverFormacaoCarga.vue";
import BtnFiltroFormCargas from "@/components/formacao-carga/BtnFiltroFormCargas.vue";
import ChipPrioridadeFormCarga from "@/components/formacao-carga/ChipPrioridadeFormCarga.vue";
import BtnAlterarPrioridadeFormCarga from "@/components/formacao-carga/BtnAlterarPrioridadeFormCarga.vue";
import CarregandoPadrao from "@/components/tela/CarregandoPadrao.vue";
export default {
  watch: {
    vendedorSelecionado: async function () {
      await this.buscarCargas();
    },
  },
  components: {
    TelaComponent,
    BtnRemoverFormacaoCarga,
    BtnFiltroFormCargas,
    ChipPrioridadeFormCarga,
    BtnAlterarPrioridadeFormCarga,
    CarregandoPadrao,
  },
  computed: {
    ...mapState("formacaoCarga", ["cargas", "configuracoes"]),
    ...mapState("usuario", ["usuarioLogado"]),
    ...mapState("relatorios", ["vendedorSelecionado"]),
  },
  data: () => ({
    pesquisar: "",
    loading: true,
  }),
  methods: {
    ...mapMutations("formacaoCarga", ["resetState"]),
    ...mapActions("formacaoCarga", ["buscarCargas", "buscarConfiguracoes"]),
    formatarData(value) {
      return moment(value).format("DD/MM/yyyy");
    },
    isMobile() {
      return this.$mq == "sm";
    },
    formatarProgCarreg(value) {
      moment.locale("pt-Br");
      return moment(value).calendar();
    },
  },
  async mounted() {
    this.loading = true;
    this.resetState();
    await this.buscarConfiguracoes();
    await this.buscarCargas();
    this.loading = false;
  },
};
</script>

<style>
</style>